import React, { memo } from 'react'
import { INavRoute } from 'types/routes'

interface ISubRouteProps {
  route: INavRoute
}

const SubRoute = memo<ISubRouteProps>(({ route: { attrs, isActive, location, name } }) => {
  const wrapperClass = `sub-menu-link-wrapper ${isActive ? 'active' : ''}`
  const titleClass = `sub-menu-link-title ${isActive ? 'active' : ''}`

  return (
    <li key={name} className={wrapperClass}>
      <a href={location} className='sub-menu-link' {...attrs}>
        <span className={titleClass}>{name}</span>
      </a>
    </li>
  )
})

export default SubRoute
